import React from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import styles from '../style/BacktestPage.module.css';
import LoginPromptToast from '../../../partials/LoginPromptToast/LoginPromptToastPeriod'; 

const formatDate = (date) => {
    if (!date) return '';
    const d = new Date(date);
    return d.toISOString().split('T')[0];
};

const BacktestOptionsSection = ({ setup, t, auth }) => {
    const navigate = useNavigate();

    const minDateStr = formatDate(setup.tenYearsAgo);
    const maxDateStr = formatDate(setup.today);

    // 기간 변경 핸들러 함수
    const handlePeriodChangeCheck = (e) => {
        const selectedValue = e.target.value;

        // 1. 10년 초과(20년, 30년) 혹은 커스텀(custom) 선택 시 로그인이 안 되어 있는 경우 체크
        // [수정 부분]: selectedValue === 'custom' 조건 추가
        if ((selectedValue === '20' || selectedValue === '30' || selectedValue === 'custom') && !auth?.user) {
            
            toast.error(
                <LoginPromptToast 
                    signInRedirect={auth?.signinRedirect} 
                    navigate={navigate} 
                />, 
                {
                    position: "top-center",
                    autoClose: false,
                    hideProgressBar: true,
                    closeOnClick: false,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                }
            );
            return; // 로그인이 안 되어 있으면 select 박스 값이 변경되지 않도록 리턴
        }

        // 2. 로그인 상태거나 10년 이하인 경우 정상 진행
        setup.handlePeriodChange(selectedValue);
    };

    return (
        <div className={styles.optionsContainer}>
            <div className={styles.optionRow}>
                <label htmlFor="backtestPeriod">{t("backtest.backtestPeriod")}</label>
                <select
                    id="backtestPeriod"
                    value={setup.isCustomPeriod ? 'custom' : setup.backtestPeriod}
                    onChange={handlePeriodChangeCheck}
                    className={styles.selectInput}
                >
                    {/* 1년 ~ 10년 (누구나 사용 가능) */}
                    {Array.from({ length: 10 }, (_, i) => i + 1).map(year => (
                        <option key={year} value={year}>{t(`backtest.${year}year${year > 1 ? 's' : ''}`)}</option>
                    ))}

                    {/* 20년, 30년 (로그인 필요) */}
                    {[20, 30].map(year => (
                        <option key={year} value={year}>
                            {t(`backtest.${year}years`)}
                            {/* {t(`backtest.${year}years`)} {!auth?.user && "🔒"} */}
                        </option>
                    ))}

                    {/* 커스텀 (로그인 필요) */}
                    <option value="custom">
                        {t("backtest.custom")} 
                        {/* {t("backtest.custom")} {!auth?.user && "🔒"} */}
                    </option> 
                </select>
            </div>
            
            {/* 1️⃣ [추가] 리밸런싱 주기 선택 UI */}
            <div className={styles.optionRow} style={{ marginTop: '10px' }}>
                <label htmlFor="rebalancePeriod">{t("backtest.rebalancePeriod") || "리밸런싱 주기"}</label>
                <select
                    id="rebalancePeriod"
                    value={setup.rebalancePeriod}
                    onChange={(e) => setup.setRebalancePeriod(e.target.value)}
                    className={styles.selectInput}
                >
                    <option value="none">{t("backtest.none") || "없음 (Buy & Hold)"}</option>
                    <option value="monthly">{t("backtest.monthly") || "월별 (Monthly)"}</option>
                    <option value="quarterly">{t("backtest.quarterly") || "분기별 (Quarterly)"}</option>
                    <option value="yearly">{t("backtest.yearly") || "연별 (Yearly)"}</option>
                </select>
            </div>

            {/* 로그인이 되어 있을 때만 커스텀 입력 필드가 나타나도록 보완 (선택 사항) */}
            {setup.isCustomPeriod && auth?.user && (
                <div className={styles.inputGroup} style={{ marginTop: '10px' }}>
                    <div className={styles.dateRangeContainer}>
                        <input
                            type="date"
                            value={setup.startDate || ''}
                            onChange={(e) => setup.setStartDate(e.target.value)}
                            min={minDateStr}
                            max={setup.endDate || maxDateStr}
                            className={styles.dateInput}
                        />
                        <span> ~ </span>
                        <input
                            type="date"
                            value={setup.endDate || ''}
                            onChange={(e) => setup.setEndDate(e.target.value)}
                            min={setup.startDate || minDateStr}
                            max={maxDateStr}
                            className={styles.dateInput}
                        />
                    </div>
                </div>
            )}
        </div>
    );
};

export default BacktestOptionsSection;